import { useCallback } from "react";
import { State } from "src/contexts/auth/store";
import { TokensPayload } from "src/hooks/useAuth";
import { setHeaderToken } from "src/services/config/apiClient";
import { isValidToken } from "src/utils/jwt";
import { log } from "src/utils/logger";

import useFetchInitialData from "./useFetchInitialData";
import useRefreshToken from "./useRefreshToken";

type Props = {
	init: () => void;
	signOut: () => void;
	signIn: (tokens: TokensPayload) => void;
};

export default function useInitAuth({ init, signIn, signOut }: Props) {
	const { mutate } = useRefreshToken({ signIn, signOut });
	const { fetchInitialData } = useFetchInitialData();

	const initializeAuth = useCallback(async () => {
		const initialState = localStorage.getItem("authState");
		if (initialState) {
			const authState: State = JSON.parse(initialState);
			if (authState.isAuthenticated && authState.token && authState.refreshToken) {
				if (!isValidToken(authState.token)) {
					log("Token no valido!");
					mutate({ refreshToken: authState.refreshToken });
				} else {
					setHeaderToken(authState.token);
					await fetchInitialData();
					signIn({
						token: authState.token,
						refreshToken: authState.refreshToken
					});
				}
			} else init();
		} else init();
	}, []);

	return { initializeAuth };
}
